import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import UserService from "@/core/services/UserService";
import SettingsService from "@/core/services/SettingsService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface User {
  name: string;
  email: string;
  password: string;
  api_token: string;
}
export interface AccountInfo {
  name: string;
  fullName: string;
  organizationName: string;
  email: string;
}
export interface UserAuthInfo {
  errors: unknown;
  user: User;
  isAuthenticated: boolean;
  accountInfo: AccountInfo;
}

@Module
export default class AuthModule extends VuexModule implements UserAuthInfo {
  errors = {};
  user = {} as User;
  isAuthenticated = !!JwtService.getToken();
  accountInfo = JSON.parse(UserService.getAccountInfo());

  /**
   * Get current user object
   * @returns User
   */
  get currentUser(): User {
    return this.user;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */
  get isUserAuthenticated(): boolean {
    return this.isAuthenticated;
  }

  /**
   * Get authentification errors
   * @returns array
   */
  get getErrors() {
    return this.errors;
  }

  get currentAccountInfo(): AccountInfo {
    return this.accountInfo;
  }

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.SET_AUTH](user) {
    this.isAuthenticated = true;
    this.user = user;
    this.errors = {};
    JwtService.saveToken(user.token);
    let info = {
      name: user.account_name,
      organizationName: user.organization_name,
      email: user.email,
      fullName: user.firstname + " " + user.lastname,
    };

    UserService.saveAccountInfo(info);
    this.accountInfo = JSON.parse(UserService.getAccountInfo());
  }

  @Mutation
  [Mutations.SET_USER](user) {
    this.user = user;
  }
  @Mutation
  [Mutations.SET_ACCOUNT_INFO](info) {
    this.accountInfo = info;
  }
  @Mutation
  [Mutations.SET_PASSWORD](password) {
    this.user.password = password;
  }

  @Mutation
  [Mutations.PURGE_AUTH]() {
    this.isAuthenticated = false;
    this.user = {} as User;
    this.errors = [];
    JwtService.destroyToken();
    UserService.destroyAccountInfo();
    SettingsService.destroySettings();
  }

  @Action
  [Actions.LOGIN](credentials) {
    return ApiService.post("login", credentials)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_AUTH, data);
      })
      .catch(({ response }) => {
        if(response.data){
          this.context.commit(Mutations.SET_ERROR, {message:'Aucun contact trouvé avec ces identifiants'});
          return;
        }
        this.context.commit(Mutations.SET_ERROR, {message:'une erreur est survenue ou vorte connexion a échoué'});
      });
  }

  @Action
  [Actions.LOGOUT]() {
    this.context.commit(Mutations.PURGE_AUTH);
  }

  @Action
  [Actions.FORGOT_PASSWORD](payload) {
    return ApiService.post("reset-password", payload)
      .then((data) => {
        this.context.commit(Mutations.SET_ERROR, {});
      })
      .catch(({ response }) => {
        if(response.data){
          this.context.commit(Mutations.SET_ERROR, {message:'Aucun contact trouvé avec cette addresse'});
          return ;
        }
        this.context.commit(Mutations.SET_ERROR, {message:"une erreur est survenue ou vorte connexion a échoué"});
      });
  }

  @Action
  [Actions.CHANGE_PASSWORD](payload) {
    return ApiService.post("password", payload)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ERROR, {});
      })
      .catch(({ response }) => {
        // console.log(response.data);
        this.context.commit(Mutations.SET_ERROR, response.data);
      });
  }
  @Action
  [Actions.VERIFY_AUTH]() {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      ApiService.get("token")
        .then(() => {
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors);
          this.context.commit(Mutations.PURGE_AUTH);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
